// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import {
    filterToLetBoards,
    loadToLetBoards,
    changeToLetBoardStatus,
} from '../../redux/reducers/toletboards';

import List from '../../components/ToLetBoards/List';
import Filter from '../../components/shared/Filter';

import OrderDetailModal from '../../components/ToLetBoards/OrderDetailModal';

import Pagination from '../../components/shared/Pagination';

import Loader from '../../components/Loader/Loader';

import { colors } from '../../shared/styles';

const ToLetBoardsWrapper = styled.div`
    display: flex;
    position: relative;

    .list {
        background: ${colors.white};
        flex-grow: 1;
    }

    .list-wrapper {
        background: ${colors.white};
        height: calc(100vh - 152px);
        overflow: hidden;
    }

    .filter {
        flex: 0 0 300px;
        background: ${colors.grey.default};
        color: ${colors.white};

        .btn {
            display: block;
            background: ${colors.orange.default};
            color: ${colors.white};
            border-radius: 4px;
            text-align: center;
            text-decoration: none;
            padding: 12px 0;
            width: 100%;
            border: 0;
            font-size: 16px;
        }

        .search-section {
            padding: 20px;
            border-bottom: solid 1px ${colors.grey.light};
        }

        h2 {
            margin: 0;
            padding: 20px 30px 20px 30px;
            font-weight: lighter;
            border-bottom: solid 1px ${colors.grey.light};
        }
    }

    .stats {
        display: block;
        text-align: center;
        font-size: 14px;
        font-stretch: normal;
        color: ${colors.darkBlue.default};
    }
`;

class ToLetBoards extends Component {
    onFilterChange: Function;
    onFilterReset: Function;
    onFilterSubmit: Function;
    onReset: Function;
    onPageChange: Function;
    onStatusChange: Function;
    onViewBoard: Function;
    onHideBoard: Function;
    state: Object;

    constructor(props) {
        super(props);

        this.onFilterChange = this.onFilterChange.bind(this);
        this.onFilterReset = this.onFilterReset.bind(this);
        this.onFilterSubmit = this.onFilterSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onStatusChange = this.onStatusChange.bind(this);
        this.onViewBoard = this.onViewBoard.bind(this);
        this.onHideBoard = this.onHideBoard.bind(this);

        this.state = {
            viewingBoardId: null,
        };
    }

    componentDidMount() {
        this.props.dispatch(loadToLetBoards(1));
    }

    onFilterChange(e) {
        this.props.dispatch(filterToLetBoards(e.target.value));
    }

    onFilterReset() {
        this.props.dispatch(filterToLetBoards(''));

        this.props.dispatch(loadToLetBoards(1));
    }

    onFilterSubmit(e) {
        e.preventDefault();

        this.props.dispatch(loadToLetBoards(1));
    }

    onReset() {
        this.props.dispatch(loadToLetBoards(1));
    }

    onPageChange(pageNo) {
        this.props.dispatch(loadToLetBoards(pageNo));
    }

    onStatusChange(boardId, newStatus) {
        const { dispatch, pagination } = this.props;

        dispatch(changeToLetBoardStatus(boardId, newStatus)).then(() => {
            dispatch(loadToLetBoards(pagination.page));
        });
    }

    onViewBoard(boardId) {
        this.setState({
            viewingBoardId: boardId,
        });
    }

    onHideBoard() {
        this.setState({
            viewingBoardId: null,
        });
    }

    render() {
        const {
            boards,
            filter,
            isFetching,
            pagination,
            total,
            fetchingTime,
            labels,
        } = this.props;

        const { viewingBoardId } = this.state;

        const boardDetail =
            viewingBoardId && boards[viewingBoardId]
                ? boards[viewingBoardId]
                : null;

        return (
            <ToLetBoardsWrapper>
                <OrderDetailModal
                    board={boardDetail}
                    isOpen={viewingBoardId !== null}
                    onCancel={this.onHideBoard}
                    labels={labels}
                />

                {/* <div className="filter">
                    <h2>To Let Boards</h2>
                    <div className="search-wrapper">
                        <div className="search-section">
                            <span className="stats">
                                {total} result{total !== 1 ? 's' : ''} found in{' '}
                                {fetchingTime}ms
                            </span>
                        </div>
                    </div>
                </div> */}

                <Filter
                    filter={filter}
                    onFilterChange={this.onFilterChange}
                    onFilterReset={this.onFilterReset}
                    onFilterSubmit={this.onFilterSubmit}
                    total={total}
                    fetchingTime={fetchingTime}
                    suffix={'To Let Board'}
                />

                <div className="list">
                    <div className="list-wrapper">
                        {(isFetching || !boards) &&
                            <Loader message="Loading to let boards, please wait..." />}

                        {!isFetching &&
                            boards &&
                            <List
                                boards={boards}
                                labels={labels}
                                onStatusChange={this.onStatusChange}
                                onViewBoard={this.onViewBoard}
                            />}
                    </div>
                    <Pagination
                        onPageChange={this.onPageChange}
                        pagination={pagination}
                    />
                </div>
            </ToLetBoardsWrapper>
        );
    }
}

const mapStateToProps = state => {
    const list = state.toletboards.list;

    return {
        errorFetching: list.error,
        filter: list.filter,
        isFetching: list.fetching,
        boards: list.boards,
        pagination: list.pagination,
        total: list.pagination.total,
        fetchingTime: list.fetchingTime,
        labels: state.toletboards.shared,
    };
};

export default connect(mapStateToProps)(ToLetBoards);



// WEBPACK FOOTER //
// ./src/containers/ToLetBoards/ToLetBoards.js